import { AppState } from 'types';

export function baseAction(state: AppState, payload: Partial<AppState>) {
	return { ...state, ...payload };
}
